import { Link as RouterLink, useLocation } from "react-router-dom";
import { Link } from "@mui/material";
import { useDispatch } from "react-redux";
import { addErrorMessage } from "../slice";

function Navlink({ href, name, Icon, disabled = false, activationUrl, ...rest }) {
  let isActive = false;
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  if (pathname.includes(activationUrl)) {
    isActive = true;
  }

  return (
    <Link
      to={!disabled && href}
      component={RouterLink}
      disabled={disabled}
      sx={{
        textDecoration: "none",
        display: "flex",
        flexDirection: "row-reverse",
        justifyContent: "flex-start",
        alignItems: "center",
        padding: "0.7rem 0.6rem",
        fontSize: "0.9rem",
        color: "#ffffff",
        borderRadius: "1rem",
        transition: "all 0.2s linear",
        backgroundColor: isActive ? "#ffffff30" : "transparent",
        ":hover": {
          backgroundColor: "#ffffff30",
        },
      }}
      {...rest}
      onClick={() => {
        if (disabled) {
          dispatch(
            addErrorMessage({
              data: {
                message: "متقاضی گرامی این قابلیت در حال حاضر فعال نیست.",
              },
            })
          );
        } else {
          if (rest.onClick) rest.onClick();
        }
      }}
    >
      <Icon color="#ffffff" style={{ marginLeft: "0.6rem", fontSize: "1.25rem" }} />
      {name}
    </Link>
  );
}

export default Navlink;
